import { Interval, TimeSpan } from '@/features/trends/trends.types';

export const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;
export const ACCORDION_HEADER_HEIGHT_REM = 3;

export const timeSpanOptions: { value: TimeSpan; label: string }[] = [
  { value: '1hr', label: '1 Hour' },
  { value: '4hrs', label: '4 Hours' },
  { value: '12hrs', label: '12 Hours' },
  { value: '24hrs', label: '24 Hours' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'date-range', label: 'Date Range' },
];

export const intervalOptions: { value: Interval; label: string }[] = [
  { value: 'per-second', label: 'Per second' },
  { value: 'per-15-seconds', label: 'Per 15 seconds' },
  { value: 'per-minute', label: 'Per minute' },
  { value: 'per-15-minutes', label: 'Per 15 minutes' },
  { value: 'per-hour', label: 'Per hour' },
];
